<script setup>
// NOOVI: Modal de import de follow-ups via CSV (Gap FU-E — fase-11).
// Cria um DataImport(data_type: follow_ups) via POST /follow-ups/import, que
// dispara o FollowUpImportJob no backend (admin/follow_up_manage).
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import FollowUpsAPI from 'dashboard/api/followUps';

const emit = defineEmits(['imported']);
const show = defineModel('show', { type: Boolean, default: false });
const { t } = useI18n();
const { showAlert } = useAlert();

const fileInput = ref(null);
const selectedFile = ref(null);
const isImporting = ref(false);

const onFileChange = () => {
  selectedFile.value = fileInput.value?.files?.[0] || null;
};

const reset = () => {
  selectedFile.value = null;
  if (fileInput.value) fileInput.value.value = null;
};

const onClose = () => {
  reset();
  show.value = false;
};

const submit = async () => {
  if (!selectedFile.value) return;

  isImporting.value = true;
  try {
    await FollowUpsAPI.importFollowUps(selectedFile.value);
    showAlert(t('FOLLOW_UPS.IMPORT.SUCCESS'));
    emit('imported');
    onClose();
  } catch (error) {
    showAlert(error?.response?.data?.error || t('FOLLOW_UPS.IMPORT.ERROR'));
  } finally {
    isImporting.value = false;
  }
};
</script>

<template>
  <Modal v-model:show="show" @close="reset">
    <div class="flex flex-col gap-4 p-6">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ t('FOLLOW_UPS.IMPORT.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('FOLLOW_UPS.IMPORT.DESCRIPTION') }}
      </p>
      <input
        ref="fileInput"
        type="file"
        accept=".csv,text/csv"
        class="text-sm text-n-slate-12"
        @change="onFileChange"
      />
      <div class="flex justify-end gap-2">
        <Button
          variant="clear"
          :label="t('FOLLOW_UPS.IMPORT.CANCEL')"
          @click="onClose"
        />
        <Button
          :label="t('FOLLOW_UPS.IMPORT.SUBMIT')"
          :is-loading="isImporting"
          :disabled="!selectedFile || isImporting"
          @click="submit"
        />
      </div>
    </div>
  </Modal>
</template>
